export default "__VITE_ASSET__DwsEC2Me__"